import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConstants } from 'src/app/shared/entity/constants';
import { TBTabName } from 'src/app/shared/models/core';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';

 
export interface DetailsType {
  element: any;
  type: string;
  tab: string
}
 
@Component({
    selector: 'app-item-details',
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss'],
    standalone: false
})
export class ItemDetailsComponent implements OnInit {
  @Input() additionalData: DetailsType;
  itemList: any[] = [];
  loading = false;
  tabName:any = TBTabName;
  displayImageDialog = false;
  @Output() showImageDialog:EventEmitter<{pnItemId:string}> = new EventEmitter<{pnItemId:string}>();
  images: any[] = [];

  constructor(private readonly connectionService: ConnectionService) {}
 
  ngOnInit(): void {
    try {
      if (this.additionalData?.type === 'goods') {
        this.getGoods();
      }
      if(this.additionalData?.type !== 'goods') {
        this.getItems();
      }
    } catch {
    }
  }
 
   getGoods(): void {
    const goods = this.additionalData?.element?.external_keys?.goods || [];
    goods.forEach((item:any) => {
      item.pn_item_id = item.pn_item_id || '';
      item.volume = this.formatVolume(item);
      item.goodsType = item.objectType
    });
    this.itemList = goods;
    this.loading = false;
  }
 
  formatVolume(item: any) {
    if (item?.depth && item?.width && item?.height) {
      return Number((item.depth * item.width * item.height) / Math.pow(10, 9)).toFixed(3);
    } else {
      return 0;
    }
  }

  openImageDialog(pn_item_id: any) {
    this.showImageDialog?.emit({pnItemId: pn_item_id})
  }


  getItems(): void {
    const taskId = this.additionalData.element?.task_id;
    if (!taskId) {
      this.loading = false;
      return;
    }
    this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `tasks/${taskId}/items`,
      directoryType: AppConstants.DP,
      isLoader: true
    }).subscribe({
      next: (res: any) => {
        if (res.items) {
          res.items.forEach((item: any) => {
            item.pn_item_id = item.pn_item_id || ''
            item.dimensions = item.dimensions || {
              depth: item.depth,
              height: item.height,
              width: item.width
            };
            item.volume = this.formatVolume(item?.dimensions)
          })
          this.itemList = res.items;
        }
        this.loading = false;
      },
      error: (error: any) => {
      }
    });
  }
 
  barcodeClicked(event: any): void {
      window.open(`#/lookup?barcode=` + event.pn_item_id, "_blank");
  }
}